/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { z } from 'zod';

import DisplayError from '@/components/atoms/Error';
import { useGet } from '@/net/commons';

/***
 * Copyright (c) Myia 2023-2024 - All Rights Reserved
 */
const RedirectToRun = () => {
    const { runId } = useParams();
    const { data, isLoading, error } = useGet(`/bff/admin/runs/${runId}`);
    const router = useNavigate();

    const schema = z.object({
        path: z.object({
            suiteSlug: z.string(),
            executionId: z.number(),
            projectSlug: z.string(),
        }),
    });

    useEffect(() => {
        let parsedData: z.infer<typeof schema>;
        if (data) {
            parsedData = schema.parse(data);
            router(
                // eslint-disable-next-line max-len
                `/run/${parsedData.path.projectSlug}/${parsedData.path.suiteSlug}/${parsedData.path.executionId}/${runId}`,
            );
        }
    }, [isLoading, data]);

    if (error) {
        return <DisplayError error={error} />;
    }
    return <div />;
};

export default RedirectToRun;
